import React, { Component } from "react";
import { Menu, Accordion, Icon, Image } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import get from "lodash/get";

import Icons from "../../assets/icons";
import "./HomeMenu.scss";
import config from "../../config";

const PRODUCT_SUBMENU_ITEMS = ["products", "bundles", "features"];
const CUSTOMERS_TABS = {
  customerGroups: "Customer Groups",
  customers: "Customers"
};
const PRODUCTS_TABS = {
  productGroups: "Product Groups",
  products: "Subscriptions",
  bundles: "Bundles",
  license_bundles: "License Bundles",
  features: "Features"
};

export class HomeMenu extends Component {
  state = {
    activeMenu: -1,
    isProductsMenuOpen: false,
    isCustomersMenuOpen: false,
    isNewDataModelsMenuOpen: false,
    currentRoute: "/"
  };
  migratedRoutes = "";

  static getDerivedStateFromProps(nextProps, state) {
    const { currentRoute } = nextProps;

    if (!state.activeTab) state.activeTab = currentRoute.replace("/", "");

    if (currentRoute !== state.currentRoute) {
      const isProductsMenuOpen = PRODUCT_SUBMENU_ITEMS.find(item => currentRoute.includes(item))
        ? true
        : state.isProductsMenuOpen;

      return { ...state, currentRoute, isProductsMenuOpen };
    } else return { ...state };
  }

  toggleProductsMenu = () =>
    this.setState((state, props) => ({
      isProductsMenuOpen: !state.isProductsMenuOpen
    }));

  toggleCustomersMenu = () =>
    this.setState((state, props) => ({
      isCustomersMenuOpen: !state.isCustomersMenuOpen
    }));

  newDataModelMenuToggleIcon = isNewDataModelsMenuOpen => `chevron ${isNewDataModelsMenuOpen ? "down" : "right"}`;
  productMenuToggleIcon = isProductsMenuOpen => `chevron ${isProductsMenuOpen ? "down" : "right"}`;
  customerMenuToggleIcon = isCustomersMenuOpen => `chevron ${isCustomersMenuOpen ? "down" : "right"}`;

  toggleActiveTab = (e, data) => {
    const selectedTab = data.to.replace("/", "");
    this.setState({ ...this.state, activeTab: selectedTab });
  };

  isRouteMigrated(route) {
    return this.migratedRoutes.includes(route);
  }

  render() {
    let { isProductsMenuOpen, isNewDataModelsMenuOpen, isCustomersMenuOpen, activeTab, currentRoute } = this.state;
    const { currentUser } = this.props;
    this.migratedRoutes = config.MIGRATED_ROUTES;

    return (
      <Accordion as={Menu} vertical borderless secondary className="no-margin">
        <Menu.Item link>
          <span data-test="menu_customer_catalog" className="menu-submenu__header" onClick={this.toggleCustomersMenu}>
            <Image inline spaced src={Icons.customers} verticalAlign="middle" />
            Customer Catalog
            <span className="menu-submenu__spacer" />
            <Icon
              className="link"
              name={this.customerMenuToggleIcon(
                isCustomersMenuOpen || !!CUSTOMERS_TABS[activeTab] || !!CUSTOMERS_TABS[currentRoute.replace("/", "")]
              )}
              color="orange"
              onClick={this.toggleCustomersMenu}
            />
          </span>
          <Accordion.Title icon={false} />
          <Accordion.Content
            active={isCustomersMenuOpen || !!CUSTOMERS_TABS[activeTab] || !!CUSTOMERS_TABS[currentRoute.replace("/", "")]}
          >
            {Object.entries(CUSTOMERS_TABS).map(([name, displayName], i) => {
              return (
                <Menu.Item
                  className="link menu-submenu__item"
                  data-test={"menu_" + name}
                  key={i + 1}
                  active={activeTab === name || currentRoute.replace("/", "") === name}
                  header={activeTab === name || currentRoute.replace("/", "") === name}
                  as={Link}
                  to={"/" + name}
                  onClick={(e, data) => this.toggleActiveTab(e, data)}
                >
                  {displayName}
                </Menu.Item>
              );
            })}
          </Accordion.Content>
        </Menu.Item>
        <Menu.Item link index={-2}>
          <span data-test="menu_prod_catalog" className="menu-submenu__header" onClick={this.toggleProductsMenu}>
            <Image inline spaced src={Icons.productCatalog} verticalAlign="middle" />
            Product Catalog
            <span className="menu-submenu__spacer" />
            <Icon
              className="link"
              name={this.productMenuToggleIcon(isProductsMenuOpen || !!PRODUCTS_TABS[activeTab])}
              color="orange"
              onClick={this.toggleProductsMenu}
            />
          </span>
          <Accordion.Title icon={false} />
          <Accordion.Content active={isProductsMenuOpen || !!PRODUCTS_TABS[activeTab]}>
            {Object.entries(PRODUCTS_TABS).map(([name, displayName], i) => (
              <Menu.Item
                className="link menu-submenu__item"
                data-test={"menu_" + name}
                key={i + 1}
                active={activeTab === name}
                header={activeTab === name}
                as={Link}
                to={"/" + name}
                onClick={(e, data) => this.toggleActiveTab(e, data)}
              >
                {displayName}
              </Menu.Item>
            ))}
          </Accordion.Content>
        </Menu.Item>
        <Menu.Item
          active={activeTab === "purchases"}
          header={activeTab === "purchases"}
          data-test="menu_purchases"
          as={Link}
          to="/purchases"
          onClick={(e, data) => this.toggleActiveTab(e, data)}
        >
          <Image inline spaced src={Icons.purchases} verticalAlign="middle" />
          Purchases
        </Menu.Item>
        <Menu.Item
          active={activeTab === "internal-invoices"}
          header={activeTab === "internal-invoices"}
          data-test="menu_internal_invoices"
          as={Link}
          to="/invoices"
          onClick={(e, data) => this.toggleActiveTab(e, data)}
        >
          <Image inline spaced src={Icons.invoices} verticalAlign="middle" />
          Internal Invoices
        </Menu.Item>
        <Menu.Item
          active={activeTab === "templates"}
          header={activeTab === "templates"}
          data-test="menu_templates"
          as={Link}
          to="/templates"
          onClick={(e, data) => this.toggleActiveTab(e, data)}
        >
          <Image inline spaced src={Icons.templates} verticalAlign="middle" />
          Templates
        </Menu.Item>
        {this.isRouteMigrated("/discounts/list") ? (
          <Menu.Item active={activeTab === "discounts"} header={activeTab === "discounts"} data-test="menu_discounts">
            <a href={"/discounts/list"}>
              <Image inline spaced src={Icons.discounts} verticalAlign="middle" />
              Discounts
            </a>
          </Menu.Item>
        ) : (
          <Menu.Item
            active={activeTab === "discounts"}
            header={activeTab === "discounts"}
            data-test="menu_discounts"
            as={Link}
            to="/discounts"
            onClick={(e, data) => this.toggleActiveTab(e, data)}
          >
            <Image inline spaced src={Icons.discounts} verticalAlign="middle" />
            Discounts
          </Menu.Item>
        )}
        {currentUser.admin === true ? (
          this.isRouteMigrated("/users") ? (
            <Menu.Item
              active={activeTab === "users"}
              header={activeTab === "users"}
              data-test="menu_admin"
              className="admin-menu"
            >
              <a href={"/users"}>
                <Icon name="user outline" />
                Admin
              </a>
            </Menu.Item>
          ) : (
            <Menu.Item
              active={activeTab === "users"}
              header={activeTab === "users"}
              data-test="menu_admin"
              className="admin-menu"
              as={Link}
              to="/users"
              onClick={(e, data) => this.toggleActiveTab(e, data)}
            >
              <Icon name="user outline" />
              Admin
            </Menu.Item>
          )
        ) : (
          ""
        )}
      </Accordion>
    );
  }
}

const mapStateToProps = state => ({
  currentRoute: get(state, "router.location.pathname"),
  currentUser: get(state, "common.currentUser")
});

export default connect(mapStateToProps)(HomeMenu);
